import { SubmitBtnProvider } from 'contexts/SubmitBtnContext'
import SendEmailForm from "./SendEmailForm"

export default function ModalSendEmail({ task }) {
  return (
    <SubmitBtnProvider>
      <SendEmailForm task={task} />
    </SubmitBtnProvider>
  )
}